import { gql } from "@apollo/client";

export const TOKEN_FRAGMENT = gql`
  fragment TokenFields on TokenType {
    accessToken
    refreshToken
  }
`;

// Employee authentication response fragment
export const EMPLOYEE_LOGIN_RESPONSE_FRAGMENT = gql`
  fragment EmployeeLoginResponseFields on EmployeeLogin {
    hasBusinessProfile
    hasEmployeeProfile
    profileImage
    message
    token {
      ...TokenFields
    }
    employeeProfile {
      id
      name
      gender
      contactNumber
      email
      address
      location
      password
      employeeId
      role
      hireDate
      joiningDate
      terminationDate
      salaryType
      baseSalary
      holidays
      bankAccount
      panNumber
      status
      createdAt
      updatedAt
      permissions {
        id
        assignedAt
        isActive
        group {
          id
          name
          description
          permissions {
            id
            module
            permissionType
            specialPermission
          }
        }
        assignedBy {
          id
          name
          employeeId
        }
      }
    }
    businessProfile {
      id
      createdAt
      updatedAt
      businessNumber
      businessName
      gstNumber
      zipcode
      city
      state
      address1
      address2
      email
      stateCode
      salesTarget
      subscriptionExpiry
      alternatePhone
      isActive
      upi
      bank
      accountHolder
      accountNumber
      ifsc
      licenseNumber
      hasActiveSubscription
    }
  }
  ${TOKEN_FRAGMENT}
`;
